export var Bundle;
(function (Bundle) {
    Bundle["Ecommerce"] = "ecommerce-b2c-bundle";
    Bundle["Survey"] = "survey-and-raffle-bundle";
    Bundle["Inquiry"] = "inquiry-bundle";
    Bundle["B2b"] = "b2b-bundle";
    Bundle["Insurance"] = "insurance-bundle";
    Bundle["MainDistributor"] = "main-distributor-bundle";
    Bundle["MultiStore"] = "mall-stores-management-bundle";
    Bundle["Affiliate"] = "affiliate-bundle";
    Bundle["Shopify"] = "shopify-bundle";
})(Bundle || (Bundle = {}));
